module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/owners/css/settings.component.css
// module id = ./src/app/modules/owners/css/settings.component.css
// module chunks = main